import { cloneDeep, find } from 'lodash';
import { renderExcludeModifier } from '@utility/utills';
import { mapStringCartToObject } from '@utility/utills';
export const updateExcludeModifier = ({
  cartItemsList,
  menuItemsHashTable,
  modifierGroupsHashTable,
  modifiersHashTable,
}) => {
  const cartTemp = cloneDeep(cartItemsList);
  cartTemp.forEach(cartItem => {
    renderExcludeModifier(
      menuItemsHashTable[cartItem.menuItemId].modifierGroupLinks,
      cartItem,
      modifierGroupsHashTable,
      modifiersHashTable,
      ''
    );
    if (cartItem?.modifiers?.length > 0) {
      cartItem.modifiers
        .filter(d => d.includes('|') && !d.includes('-0'))
        .forEach(d => {
          renderExcludeModifier(
            modifiersHashTable[d.split('|')[0].split('-')[0]]
              .modifierGroupLinks,
            cartItem,
            modifierGroupsHashTable,
            modifiersHashTable,
            `${d.split('|')[0]}|`
          );
        });
    }
  });
  return cartTemp;
};

export const renderInitialData = ({
  menuItemsHashTable,
  modifierGroupsHashTable,
  modifiersHashTable,
  activeMenuItemId,
  menuItemId,
}) => {
  const modifierList = menuItemsHashTable[menuItemId].modifierGroupLinks.map(
    item => ({
      ...item,
      ...modifierGroupsHashTable[item.modifierGroupId],
    })
  );
  const preSelectModList = [];
  modifierList.forEach(modGroup => {
    if (
      modGroup.hiddenMenuId === activeMenuItemId &&
      modGroup.hiddenAutoAddModifierId &&
      modifiersHashTable[modGroup.hiddenAutoAddModifierId]
    ) {
      preSelectModList.push(
        `${modGroup.hiddenAutoAddModifierId}-${modGroup.id}`
      );
    }
  });
  return preSelectModList;
};
export const applyModFunction = ({
  cartItemsList,
  modifierGroupsHashTable,
}) => {
  cartItemsList.forEach(cartItem => {
    if (cartItem.modifiers && cartItem.modifiers.length > 0) {
      cartItem.modifiers.forEach(modifier => {
        modifier.split('|').forEach((mod, i) => {
          if (
            mod.split('-')[1] &&
            modifierGroupsHashTable[mod.split('-')[1]]?.applyModFunction
          ) {
            if (
              i === 0 &&
              !cartItem.modifiers.includes(
                `${mod}|${
                  modifierGroupsHashTable[mod.split('-')[1]]
                    .modFunctionModifierId
                }-${
                  modifierGroupsHashTable[mod.split('-')[1]]
                    .modFunctionModifierGroupId
                }`
              )
            ) {
              cartItem.modifiers.push(
                `${mod}|${
                  modifierGroupsHashTable[mod.split('-')[1]]
                    .modFunctionModifierId
                }-${
                  modifierGroupsHashTable[mod.split('-')[1]]
                    .modFunctionModifierGroupId
                }`
              );
            } else if (
              !cartItem.modifiers.includes(
                `${modifier}|${
                  modifierGroupsHashTable[mod.split('-')[1]]
                    .modFunctionModifierId
                }-${
                  modifierGroupsHashTable[mod.split('-')[1]]
                    .modFunctionModifierGroupId
                }`
              )
            ) {
              cartItem.modifiers.push(
                `${modifier}|${
                  modifierGroupsHashTable[mod.split('-')[1]]
                    .modFunctionModifierId
                }-${
                  modifierGroupsHashTable[mod.split('-')[1]]
                    .modFunctionModifierGroupId
                }`
              );
            }
          }
        });
      });
    }
  });
  return cartItemsList;
};

export const calculateModifierAmount = ({
  modifierData,
  modifierGroupsHashTable,
}) => {
  let modiferPrice = 0;
  const modifierObject = mapStringCartToObject(
    [{ modifiers: modifierData }],
    []
  );

  const getModifierAmount = modifierList => {
    modifierList.forEach(mod => {
      modiferPrice +=
        mod.quantity *
        Number(
          find(
            modifierGroupsHashTable[mod.modifierGroupId].modifierLinks,
            d => d.modifierId === Number(mod.modifierId)
          ).price
        );
      if (mod.modifiers) {
        getModifierAmount(mod.modifiers);
      }
    });
  };
  getModifierAmount(modifierObject[0].modifiers);
  return modiferPrice;
};
export const checkRequiredModifierCount = ({
  menuItemId,
  menuId,
  menuItemsHashTable,
  modifierGroupsHashTable,
}) => {
  const requiredModifierList = [];
  menuItemsHashTable[menuItemId].modifierGroupLinks.forEach(item => {
    if (
      modifierGroupsHashTable[item.modifierGroupId].minimum > 0 &&
      modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId !== menuId
    ) {
      requiredModifierList.push({ ...item });
    }
    if (modifierGroupsHashTable[item.modifierGroupId].flowRequired) {
      requiredModifierList.push({ ...item });
    }
  });
  return requiredModifierList.length;
};
